import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { randomString } from '../../utils/string';
import { RadioReturnType } from './radio.types';
import { radioProps } from './radio.utils';

@Component({
  selector: 'cohrex-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RadioComponent implements OnInit, OnChanges {
  props?: RadioReturnType;

  private _color?: string = 'primary';
  @Input()
  set color(value: string | undefined) {
    this._color = value;
  }
  get color(): string | undefined {
    return this._color;
  }

  private _helperText?: string = '';
  @Input()
  set helperText(value: string | undefined) {
    this._helperText = value;
  }
  get helperText(): string | undefined {
    return this._helperText;
  }

  private _isError?: boolean = false;
  @Input()
  set isError(value: boolean | undefined) {
    this._isError = value;
  }
  get isError(): boolean | undefined {
    return this._isError;
  }

  private _controlName?: string = '';
  @Input()
  set controlName(value: string | undefined) {
    this._controlName = value;
  }
  get controlName(): string | undefined {
    return this._controlName;
  }

  private _form?: FormGroup;
  @Input()
  set form(value: FormGroup | undefined) {
    this._form = value;
  }
  get form(): FormGroup | undefined {
    return this._form;
  }

  private _radioIndex?: number;
  @Input()
  set radioIndex(value: number | undefined) {
    this._radioIndex = value;
  }
  get radioIndex(): number | undefined {
    return this._radioIndex;
  }

  @Input() name: string = '';
  @Input() value: string = '';
  @Input() label: string = '';
  @Input() radioIdex: string = '';

  @Output()
  selected = new EventEmitter<{ checked: boolean; value: string }>();

  ObjectKeys = Object.keys;

  ngOnInit(): void {
    this.initProps();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.radioIdex = randomString();
    this.initProps();
  }

  initProps() {
    this.props = radioProps({
      color: this.color
    });
  }

  handleRadioSelected(event: Event) {
    const { value, checked } = event.target as HTMLInputElement;
    this.selected.emit({
      checked,
      value
    });
  }
}
